import { useEffect } from 'react';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { SelectStateFieldSection } from './SelectStateFieldSection';
import styled from 'styled-components';
import { MTTR_STRATEGY } from '@linearb/linjs-common';
import { TRANSITION_POSITION } from './MTTRDuration';
import { getColor } from 'common/constants/_colors';

const StyledContainer = styled(Flex)`
  border: 1px solid #d8deea;
  border-radius: 3px;
  min-width: 40rem;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;

  overflow: auto;
  background-color: ${getColor('zircon')};
`;

const StateTransitionLabel = ({ position }) => {
  return (
    <Text size='medium'>
      When issue{' '}
      {position === TRANSITION_POSITION.START.key ? 'enters' : 'exits'} state
      "In Progress"
    </Text>
  );
};

export const TransitionConfig = ({
  customFields,
  selectedStrategy,
  onChangeStrategy,
  customFieldTransition,
  setCustomFieldTransition,
  position = TRANSITION_POSITION.START,
  dataCyPrefix
}) => {
  useEffect(() => {
    if (!!customFieldTransition) {
      onChangeStrategy({
        target: {
          value: MTTR_STRATEGY.CUSTOM_FIELD_TRANSITION
        }
      });
    }
  }, [customFieldTransition]);

  return (
    <StyledContainer items='center'>
      <Flex direction='column' ml='x-medium'>
        <Text weight='bold' size='medium'>
          {position?.title?.toUpperCase()}
        </Text>
        <RadioGroup>
          <FormControlLabel
            value={MTTR_STRATEGY.STATE_TRANSITION}
            onChange={onChangeStrategy}
            label={<StateTransitionLabel position={position.key} />}
            control={
              <Radio
                data-testid='state-transition-option'
                checked={selectedStrategy === MTTR_STRATEGY.STATE_TRANSITION}
                color='primary'
              />
            }
            data-cy={`${dataCyPrefix}-when-enters`}
          />
          <Flex direction='column'>
            <FormControlLabel
              value={MTTR_STRATEGY.CUSTOM_FIELD_TRANSITION}
              onChange={onChangeStrategy}
              label={
                <>
                  <SelectStateFieldSection
                    title='From date and time field'
                    itemsList={customFields}
                    buttonTitle='Select custom field'
                    selectedItem={customFieldTransition}
                    setSelectedItem={setCustomFieldTransition}
                  />
                </>
              }
              control={
                <Radio
                  data-testid='custom-field-transition-option'
                  checked={
                    selectedStrategy === MTTR_STRATEGY.CUSTOM_FIELD_TRANSITION
                  }
                  color='primary'
                />
              }
              data-cy={`${dataCyPrefix}-from-date`}
            />
          </Flex>
        </RadioGroup>
      </Flex>
    </StyledContainer>
  );
};
